import r from"../_lib/requiredArgs/index.js";import e from"../isDate/index.js";import i from"../toDate/index.js";export default function(t){if(r(1,arguments),!e(t)&&"number"!=typeof t)return!1;var o=i(t);return!isNaN(Number(o))}
